// extracted by mini-css-extract-plugin
module.exports = {"Container":"BatchRegistrationTable_Container__343vN","NoData":"BatchRegistrationTable_NoData__35Wes"};